// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .profile-logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    margin-left: 20px;
    border: 2px solid #2865AA;
}

.navbar-right {
    display: flex;
    align-items: center;
    gap: 15px; 
}

.text-container {
    display: flex;
    flex-direction: column;
    margin-left: 10px; 
}

.text-container h1 {
    margin: 0;
    font-size: 26px; 
    font-weight: bold;
}

.text-container h3 {
    margin-top: 5px; 
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    color: gray;
}

.middle-space {
    background-color: #2865AA;
    height: 10px;
    width: 100%;
    box-shadow: 0px 6px 10px rgb(0, 0, 0, 0.2);
    margin-top: 20px;
}



@media (min-width: 768px) {
    .scrollbar {
        transform: translateX(0) !important;
    }
} */

.profile-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  margin-left: 20px;
  border: 2px solid #2865aa;
  margin-top: 20px;
}

.navbar-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  position: relative; /* ✅ Ensures sidebar-toggle is positioned correctly */
  background-color: #fff;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.text-container {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  text-align: center;
}

.text-container h1 {
  margin: 0;
  font-size: 26px;
  font-weight: bold;
}

.text-container h3 {
  margin-top: 5px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  color: gray;
}

.middle-space {
  background-color: #2865aa;
  height: 10px;
  width: 100%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
  margin-top: 20px;
}

/* Default: Hide Dashboard & Sidebar Toggle */
.dashboard,
.sidebar-toggle {
  display: none;
}

/* Mobile View */
@media (max-width: 768px) {
  .navbar-right {
    flex-direction: row;
    gap: 5px;
    text-align: center;
    /* justify-content: center; */
    align-items: center;
    flex: start 1;
    padding: 12px;
  }

  .navbar-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100vw;
    background-color: #2865aa;
    position: fixed;
    top: 0;
    left: 0;
    /* padding: 15px 10px; */
    height: 15vw;
    /* margin-bottom: 50px; */
  }

  /* .mobile-profile {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        background-color: white;
        border-radius: 10px;
        width: 90%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    } */

  /* Center the Dashboard text in mobile view */
  .dashboard {
    display: block;
    color: white;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    margin-top: 16px;
  }

  /* ✅ Show Sidebar Toggle properly */
  .sidebar-toggle {
    display: flex;
    width: 15vw;
    height: 100%;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: white;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .profile-logo {
    width: 60px;
    height: 60px;
    margin-left: 0;
    margin-top: 20px;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    text-align: center;
    margin-bottom: 20px;
  }

  .text-container h1 {
    font-size: 20px;
  }

  .text-container h3 {
    font-size: 13px;
  }

  .middle-space {
    background-color: #2865aa;
    height: 10px;
    width: 100%;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);
    margin-top: 20px;
  }
  .middle-space {
    display: none;
  }

  .main-content {
    padding-top: 50px;
    overflow-y: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB,EAAE,qDAAqD;EACzE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;;EAEE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE;IACE,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAW;IACX,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;;;;;;;;;;;;;OAaK;;EAEL,6CAA6C;EAC7C;IACE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,2CAA2C;IAC3C,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["/* .profile-logo {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-left: 20px;\n    border: 2px solid #2865AA;\n}\n\n.navbar-right {\n    display: flex;\n    align-items: center;\n    gap: 15px; \n}\n\n.text-container {\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px; \n}\n\n.text-container h1 {\n    margin: 0;\n    font-size: 26px; \n    font-weight: bold;\n}\n\n.text-container h3 {\n    margin-top: 5px; \n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: normal;\n    color: gray;\n}\n\n.middle-space {\n    background-color: #2865AA;\n    height: 10px;\n    width: 100%;\n    box-shadow: 0px 6px 10px rgb(0, 0, 0, 0.2);\n    margin-top: 20px;\n}\n\n\n\n@media (min-width: 768px) {\n    .scrollbar {\n        transform: translateX(0) !important;\n    }\n} */\n\n.profile-logo {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-left: 20px;\n  border: 2px solid #2865aa;\n  margin-top: 20px;\n}\n\n.navbar-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  position: relative; /* ✅ Ensures sidebar-toggle is positioned correctly */\n  background-color: #fff;\n}\n\n.navbar-right {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.text-container {\n  display: flex;\n  flex-direction: column;\n  margin-left: 10px;\n  text-align: center;\n}\n\n.text-container h1 {\n  margin: 0;\n  font-size: 26px;\n  font-weight: bold;\n}\n\n.text-container h3 {\n  margin-top: 5px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: normal;\n  color: gray;\n}\n\n.middle-space {\n  background-color: #2865aa;\n  height: 10px;\n  width: 100%;\n  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);\n  margin-top: 20px;\n}\n\n/* Default: Hide Dashboard & Sidebar Toggle */\n.dashboard,\n.sidebar-toggle {\n  display: none;\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n  .navbar-right {\n    flex-direction: row;\n    gap: 5px;\n    text-align: center;\n    /* justify-content: center; */\n    align-items: center;\n    flex: start;\n    padding: 12px;\n  }\n\n  .navbar-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100vw;\n    background-color: #2865aa;\n    position: fixed;\n    top: 0;\n    left: 0;\n    /* padding: 15px 10px; */\n    height: 15vw;\n    /* margin-bottom: 50px; */\n  }\n\n  /* .mobile-profile {\n        position: fixed;\n        bottom: 20px;\n        left: 50%;\n        transform: translateX(-50%);\n        background-color: white;\n        border-radius: 10px;\n        width: 90%;\n        height: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n    } */\n\n  /* Center the Dashboard text in mobile view */\n  .dashboard {\n    display: block;\n    color: white;\n    font-size: 18px;\n    font-weight: 600;\n    text-align: center;\n    width: 100%;\n    margin-top: 16px;\n  }\n\n  /* ✅ Show Sidebar Toggle properly */\n  .sidebar-toggle {\n    display: flex;\n    width: 15vw;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    font-size: 24px;\n    color: white;\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 10;\n  }\n\n  .profile-logo {\n    width: 60px;\n    height: 60px;\n    margin-left: 0;\n    margin-top: 20px;\n  }\n\n  .text-container {\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\n  .text-container h1 {\n    font-size: 20px;\n  }\n\n  .text-container h3 {\n    font-size: 13px;\n  }\n\n  .middle-space {\n    background-color: #2865aa;\n    height: 10px;\n    width: 100%;\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.2);\n    margin-top: 20px;\n  }\n  .middle-space {\n    display: none;\n  }\n\n  .main-content {\n    padding-top: 50px;\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
